var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.invokePartial(require("../help_link_widget.hbs"),depth0,{"name":"../help_link_widget","hash":{"link":lookupProperty(depth0,"help_link_widget_link")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"language_selection_widget input-group prop-element\" id=\"id_"
    + alias3(alias2(alias1(depth0, "section_name", {"start":{"line":1,"column":73},"end":{"line":1,"column":85}} ), depth0))
    + "\">\n    <label class=\"title\">\n        "
    + alias3(alias2(alias1(depth0, "section_title", {"start":{"line":3,"column":10},"end":{"line":3,"column":23}} ), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"help_link_widget_link"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "    </label>\n    <button type=\"button\" class=\"language_selection_button button rounded small\" data-section=\""
    + alias3(alias2(alias1(depth0, "section_name", {"start":{"line":8,"column":97},"end":{"line":8,"column":109}} ), depth0))
    + "\">\n        <span class=\""
    + alias3(alias2(alias1(depth0, "section_name", {"start":{"line":9,"column":23},"end":{"line":9,"column":35}} ), depth0))
    + "\" data-language-code=\""
    + alias3(alias2(alias1(depth0, "language_code", {"start":{"line":9,"column":61},"end":{"line":9,"column":74}} ), depth0))
    + "\">"
    + alias3(alias2(alias1(depth0, "setting_value", {"start":{"line":9,"column":80},"end":{"line":9,"column":93}} ), depth0))
    + "</span>\n        <i class=\"fa fa-pencil\"></i>\n    </button>\n</div>\n";
},"usePartial":true,"useData":true});